import { render, staticRenderFns } from "./t_word.vue?vue&type=template&id=42987fcc&"
import script from "./t_word.vue?vue&type=script&lang=js&"
export * from "./t_word.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports